export default __webpack_public_path__ + "static/media/leaderboard_728.b459f9dd.png";